import { getAdminCountEventsProps } from './admin/event/getAdminCountEvents';
import { GetAdminEventParams } from './admin/event/getAdminEvent';
import { GetAdminEventsParams } from './admin/event/getAdminEvents';
import { GetAdminEventTicketsParams } from './admin/eventTicket/getAdminEventTickets';
import { getAdminCountPlacesProps } from './admin/place/getAdminCountPlaces';
import { GetAdminPlaceParams } from './admin/place/getAdminPlace';
import { GetAdminPlacesParams } from './admin/place/getAdminPlaces';
import { GetAdminGlobalPlacesProps } from './admin/statistics/place/getAdminGlobalPlaces';
import { GetAdminActiveUsersProps } from './admin/statistics/user/getAdminActiveUsers';
import { GetAdminRegisteredUsersProps } from './admin/statistics/user/getAdminRegisteredUsers';
import { GetAdminTransactionsUsersProps } from './admin/statistics/user/getAdminTransactionsUsers';
import { getAdminCountUsersProps } from './admin/user/getAdminCountUsers';
import { GetAdminUserParams } from './admin/user/getAdminUser';
import { GetAdminUsersParams } from './admin/user/getAdminUsers';
import { GetEventParams } from './event/getEvent';
import { GetEventsParams } from './event/getEvents';
import { GetEventTicketsParams } from './eventTicket/getUserEventTickets';
import { GetGroupedEventTicketsParams } from './eventTicket/useGroupedEventTickets';
import { GetEventTicketTypesParams } from './eventTicketType/getEventTicketTypes';
import { formatParams } from './nodeAxiosService';
import { GetPlaceParams } from './place/getPlace';
import { GetPlaceUserByPlaceIdParams } from './placeUser/getPlaceUserByPlaceId';

export const API_ROUTES = {
  /*********
   * ADMIN *
   *********/
  // Stats
  getAdminGlobalPlaces: (params?: GetAdminGlobalPlacesProps) =>
    `/admin/places/stats/global?${formatParams(params)}`,
  getAdminRevenueByPlace: (params?: GetAdminGlobalPlacesProps) =>
    `/admin/places/stats/revenue-by-place?${formatParams(params)}`,

  getAdminGlobalUsers: () => `/admin/users/stats/global`,
  getAdminTransactionsUsers: (params?: GetAdminTransactionsUsersProps) =>
    `/admin/users/stats/transactions?${formatParams(params)}`,
  getAdminRegisteredUsers: (params?: GetAdminActiveUsersProps) =>
    `/admin/users/stats/registered?${formatParams(params)}`,
  getAdminActiveUsers: (params?: GetAdminRegisteredUsersProps) =>
    `/admin/users/stats/active?${formatParams(params)}`,

  transferPlaceFollowersUrl: (placeId: string) =>
    `/admin/places/${placeId}/transfer-followers`,

  // Events
  getAdminEventsUrl: (params?: GetAdminEventsParams) =>
    `/admin/events?${formatParams(params)}`,
  getAdminEventUrl: (id: string, params?: GetAdminEventParams) =>
    `/admin/events/${id}?${formatParams(params)}`,
  updateAdminEventUrl: (id: string) => `/admin/events/${id}`,
  unaffiliateAdminEventUrl: (id: string) =>
    `/admin/events/unaffiliate/${id}/manager`,
  linkAffiliatedPlacesFollowersUrl: () => '/admin/events/link-followers',
  makeEventParticipantsFollowAffiliatedPlaceUrl: () =>
    '/admin/events/link-participants',
  getAdminCountEventsUrl: (params?: getAdminCountEventsProps) =>
    `/admin/events/count?${formatParams(params)}`,

  // Events tickets
  getAdminEventTicketsUrl: (
    eventId: string,
    params?: GetAdminEventTicketsParams
  ) => `/admin/events/${eventId}/event-tickets?${formatParams(params)}`,
  getAdminEventTicketCountUrl: (
    eventId: string,
    params?: GetAdminEventTicketsParams
  ) => `/admin/events/${eventId}/event-tickets/count?${formatParams(params)}`,

  // Places
  getAdminPlacesUrl: (params?: GetAdminPlacesParams) =>
    `/admin/places?${formatParams(params)}`,
  getAdminPlaceUrl: (id: string, params?: GetAdminPlaceParams) =>
    `/admin/places/${id}?${formatParams(params)}`,
  updateAdminPlaceUrl: (id: string) => `/admin/places/${id}`,
  getAdminCountPlacesUrl: (params?: getAdminCountPlacesProps) =>
    `/admin/places/count?${formatParams(params)}`,

  // Users
  getAdminUsersUrl: (params?: GetAdminUsersParams) =>
    `/admin/users?${formatParams(params)}`,
  getAdminUserUrl: (id: string, params?: GetAdminUserParams) =>
    `/admin/users/${id}?${formatParams(params)}`,
  updateAdminUserUrl: (id: string) => `/admin/users/${id}`,
  getAdminCountUsersUrl: (params?: getAdminCountUsersProps) =>
    `/admin/users/count?${formatParams(params)}`,

  /********
   * USER *
   ********/
  // Discounts
  getDiscountsUrl: (queryString: string) => `/discounts${queryString}`,
  activateDiscountUrl: () => `/discounts/use`,

  // DiscountSchedules
  getDiscountSchedulesUrl: (queryString: string) =>
    `/discount-schedules${queryString}`,

  // Event
  getEventUrl: (eventId: string, params?: GetEventParams) =>
    `/events/${eventId}?${formatParams(params)}`,
  getEventsUrl: (params?: GetEventsParams) => `/events?${formatParams(params)}`,

  // Event Ticket Type
  getEventTicketTypesUrl: (params?: GetEventTicketTypesParams) =>
    `event-ticket-types?${formatParams(params)}`,
  // EventManagerQuestions
  getEventManagerQuestionsUrl: (queryString: string) =>
    `/event-manager-questions${queryString}`,
  getEventManagerQuestionUrl: (questionId: string) =>
    `/event-manager-questions/${questionId}`,

  // EventUserAnswer
  getEventUserAnswersUrl: (queryString: string) =>
    `/event-user-answers${queryString}`,
  getEventUserAnswerUrl: (answerId: string) =>
    `/event-user-answers/${answerId}`,
  createEventUserAnswerUrl: () => `/event-user-answers`,

  // Event Ticket
  createEventTicketUrl: () => `/event-tickets`,
  getEventTicketUrl: (ticketId: string) => `/event-tickets/${ticketId}`,
  getUserEventTicketsUrl: (params?: GetEventTicketsParams) =>
    `/event-tickets?${formatParams(params)}`,
  getGroupedEventTickets: (params?: GetGroupedEventTicketsParams) =>
    `/event-tickets/group-payment?${formatParams(params)}`,

  // Order
  createOrderUrl: () => `/orders`,
  getOrderUrl: (orderId: string) => `/orders/${orderId}`,
  getOrdersByPlaceUrl: (queryString: string) => `orders/${queryString}`,
  getCountOrdersByPlaceUrl: (queryString: string) =>
    `orders/count${queryString}`,

  // Payments
  createPaymentIntentUrl: () => `/payment-methods/create-setup-intent`,
  getUserPaymentMethodsUrl: () => `/payment-methods`,

  // Place
  getPlaceUrl: (placeId: string, params?: GetPlaceParams) =>
    `/places/${placeId}?${formatParams(params)}`,

  getPlaceUserByPlaceIdUrl: (
    placeId: string,
    params?: GetPlaceUserByPlaceIdParams
  ) => `/place-users/place/${placeId}?${formatParams(params)}`,

  // Service table
  getServiceTableUrl: (serviceTableId: string) =>
    `/service-tables/${serviceTableId}`,
  getServiceTablesByPlaceUrl: (placeId: string) =>
    `/service-tables?place=${placeId}`,

  // Products
  createProductUrl: () => `/products`,
  getPlaceProductsUrl: (placeId: string) => `/products?place=${placeId}`,

  // Product Categories
  getProductCategoriesUrl: () => `/product-categories`,

  // Storage
  getFileUrl: (fileId: string) => `/storage/${fileId}/preview?width=500`,

  // User
  oauthLoginUrl: () => `/users/oauth-login`,
  loginUrl: () => `/users/login`,
  meUrl: () => `/users/me`,
  passwordResetUrl: () => `/users/password-reset`,
  refreshTokenUrl: () => `/auth/refresh`,
  registerUrl: () => `/users/register`,
  registerGuestUrl: () => `/users/register`,
  requestDeletionUrl: () => `/users/request-deletion`,
  resetPassword: (tokenId: string) => `/users/password-setup/${tokenId}`,
  confirmDeletion: (tokenId: string) => `/users/confirm-deletion/${tokenId}`,
  activateAccount: (tokenId: string) => `/users/activation/${tokenId}`,
};
